import React from "react";
import {
  AutocompleteInput,
  Edit,
  ReferenceInput,
  // SelectInput,
  SimpleForm,
  TextInput,
} from "react-admin";

export const filterTenantTypes = {
  // Allow only: Dealer, Admin
  id: [1, 2],
};

export const MsgTypeEdit = props => (
  <Edit mutationMode="pessimistic" {...props}>
    <SimpleForm>
      <TextInput
        source="name"
        label="Display name"
        autoFocus
        fullWidth
        isRequired
      />
      <TextInput source="description" fullWidth />
      <ReferenceInput
        source="tenantTypeId"
        reference="lists/tenant_types"
        label="Available to"
        filter={filterTenantTypes}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);
